import { useEffect } from 'react';

/**
 * Hook to fix mobile viewport issues
 * Addresses common mobile browser viewport height problems
 */
export function useMobileViewportFix() {
  useEffect(() => {
    const handleResize = () => {
      // Get the viewport height and multiply by 1% to get a value for a vh unit
      const vh = window.innerHeight * 0.01;
      // Set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    const handleOrientationChange = () => {
      // Delay the resize handler to allow the browser to update the viewport
      setTimeout(handleResize, 100);
    };

    // Initial calculation
    handleResize();

    // Listen for resize events
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleOrientationChange);

    // Cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleOrientationChange);
    };
  }, []);
}
